import { merge } from 'lodash'
import {
  LOGIN_ERROR,
  LOGOUT_ERROR,
  POST_OTP_ERROR,
  POST_DETAILS_ERROR,
  VIEW_AS_ADMIN_ERROR,
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  POST_OTP_SUCCESS,
  POST_DETAILS_SUCCESS,
  VIEW_AS_ADMIN_SUCCESS,
  MAKE_DEFAULT_ERROR,
  ADD_EMAIL_ERROR,
  DELETE_EMAIL_ERROR,
  ADD_EMAIL_SUCCESS,
  DELETE_EMAIL_SUCCESS,
  RESEND_SMS_ERROR,
  EMAIL_OTP_ERROR,
  RESEND_SMS_SUCCESS,
  EMAIL_OTP_SUCCESS,
  SEND_VERIFICATION_SUCCESS,
  SEND_VERIFICATION_ERROR
} from '../actions/login-actions'

import { USER_UPDATED_ERROR } from '../actions/as-admin'

export default (state = {}, action) => {
  switch (action.type) {
    case LOGIN_ERROR:
    case LOGOUT_ERROR:
    case POST_OTP_ERROR:
    case POST_DETAILS_ERROR:
    case VIEW_AS_ADMIN_ERROR:
    case MAKE_DEFAULT_ERROR:
    case ADD_EMAIL_ERROR:
    case DELETE_EMAIL_ERROR:
    case EMAIL_OTP_ERROR:
    case SEND_VERIFICATION_ERROR:
    case RESEND_SMS_ERROR:
    case USER_UPDATED_ERROR:
      return merge({}, {
        err: action.err
      })
    case LOGIN_SUCCESS:
    case LOGOUT_SUCCESS:
    case POST_OTP_SUCCESS:
    case POST_DETAILS_SUCCESS:
    case VIEW_AS_ADMIN_SUCCESS:
    case ADD_EMAIL_SUCCESS:
    case DELETE_EMAIL_SUCCESS:
      return merge({}, {})
    case RESEND_SMS_SUCCESS:
    case EMAIL_OTP_SUCCESS:
    case SEND_VERIFICATION_SUCCESS:
      return merge({}, {
        err: action.msg
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/errors.js